/* eslint-disable no-restricted-globals -- کلید phoenix.color-mode فقط ترجیح ظاهر است، نه توکن (C-AGENT-1141). */
import { createContext, useContext } from 'react';
import type { ColorMode } from './createPhoenixTheme';

/** ترجیح ظاهر. توکن احراز هویت اینجا ذخیره نمی‌شود. */
export const COLOR_MODE_STORAGE_KEY = 'phoenix.color-mode';

export function readColorMode(): ColorMode {
  if (typeof localStorage === 'undefined') {
    return 'light';
  }

  try {
    const stored = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function writeColorMode(mode: ColorMode): void {
  try {
    localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
  } catch {
    // حالت خصوصی مرورگر؛ انتخاب فقط تا بستن صفحه می‌ماند.
  }
}

export function clearColorMode(): void {
  try {
    localStorage.removeItem(COLOR_MODE_STORAGE_KEY);
  } catch {
    // همان محدودیت حالت خصوصی.
  }
}

export interface ColorModeContextValue {
  mode: ColorMode;
  setMode: (mode: ColorMode) => void;
}

export const ColorModeContext = createContext<ColorModeContextValue | null>(null);

export function useColorMode(): ColorModeContextValue {
  const value = useContext(ColorModeContext);
  if (!value) {
    throw new Error('useColorMode requires PhoenixThemeProvider');
  }
  return value;
}
